import React from 'react';
import { WorkoutSlotProps } from '../types/calendar';

const WorkoutSlot: React.FC<WorkoutSlotProps> = ({ workout, onClick, isCompact = false }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(workout);
    }
  };

  const getClientNames = (): string => {
    if (!workout.clients || workout.clients.length === 0) {
      return 'Нет клиентов';
    }
    
    if (workout.clients.length === 1) {
      return `${workout.clients[0].first_name} ${workout.clients[0].last_name}`;
    }
    
    return `${workout.clients[0].first_name} +${workout.clients.length - 1}`;
  };

  const getClientNamesForTooltip = (): string => {
    if (!workout.clients || workout.clients.length === 0) {
      return 'Нет клиентов';
    }
    
    return workout.clients
      .map(client => `${client.first_name} ${client.last_name}`)
      .join('\n');
  };

  const formatTime = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('ru-RU', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getDurationText = (): string => {
    if (!workout.duration_minutes) {
      return formatTime(workout.date);
    }
    return `${formatTime(workout.date)} (${workout.duration_minutes} мин)`;
  };

  const getWorkoutColor = (): string => {
    if (workout.is_completed) {
      return 'bg-green-50 text-green-700 border border-green-200';
    }
    return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
  };

  return (
    <div
      onClick={handleClick}
      className={`rounded-none cursor-pointer transition-all hover:shadow-sm h-full flex flex-col items-center justify-center ${getWorkoutColor()} ${isCompact ? 'text-[10px]' : 'text-xs'}`}
      title={`${workout.name}\n\nКлиенты:\n${getClientNamesForTooltip()}`}
    >
      {/* Время и длительность */}
      <div className="text-center font-medium leading-tight">
        {getDurationText()}
      </div>
      
      {/* Клиенты */}
      <div className="text-center leading-tight">
        {getClientNames()}
        {workout.is_completed && (
          <span className={`inline-block rounded-full ml-1 ${isCompact ? 'w-1 h-1' : 'w-1.5 h-1.5'} bg-green-500`}></span>
        )}
      </div>
    </div>
  );
};

export default WorkoutSlot; 